import { alchemy, polygon } from '@account-kit/infra'
import { createMigrationConfig } from '@privy-io/alchemy-migration'
import type { PrivyClientConfig } from '@privy-io/react-auth'

export const PRIVY_APP_ID = process.env.NEXT_PUBLIC_PRIVY_APP_ID ?? ''
export const PRIVY_CLIENT_ID = process.env.NEXT_PUBLIC_PRIVY_CLIENT_ID ?? ''

export const privyClientConfig: PrivyClientConfig = {
	// Headless login does not auto-create wallets and migrating users must
	// NOT get fresh wallets before the migration SDK runs — creation is
	// handled explicitly by EmbeddedWalletBootstrap in WalletProvider.
	embeddedWallets: {
		ethereum: { createOnLogin: 'off' },
		solana: { createOnLogin: 'off' },
	},
}

// Re-authentication UI config used by MigrationProvider while transferring
// keys for users who signed up with Alchemy email/Google auth.
export const alchemyMigrationConfig = createMigrationConfig(
	{
		transport: alchemy({ apiKey: process.env.NEXT_PUBLIC_ALCHEMY_API_KEY ?? '' }),
		chain: polygon,
		ssr: true,
	},
	{
		auth: {
			sections: [
				[{ type: 'email' }],
				[{ type: 'social', authProviderId: 'google', mode: 'popup' }],
			],
		},
	}
)
